package com.daytimegaming.ourdailyfinances.domain.model

data class RealEstateValueEstimate(
    val date: String,
    val estimatedValue: Double,
    val priceRangeLow: Double?,
    val priceRangeHigh: Double?
)

data class RealEstateHolding(
    val realEstateHoldingId: String,
    val userId: String?,
    val nickname: String,
    val addressLine1: String,
    val addressLine2: String?,
    val city: String,
    val state: String,
    val zipCode: String,
    val county: String?,
    val purchasePrice: Double,
    val mortgageAmount: Double?,
    val mortgageInterestRate: Double?,
    val createdAt: String?,
    val addedByUserId: String?,
    val valueEstimates: List<RealEstateValueEstimate> = emptyList()
) {
    val netValue: Double
        get() {
            val latestEstimate = valueEstimates.maxByOrNull { it.date }
            val baseValue = latestEstimate?.estimatedValue ?: purchasePrice
            return baseValue - (mortgageAmount ?: 0.0)
        }
}
